<article class="project-card-content">
  <div class="d-flex align-items-start gap-3">
    <span class="project-avatar">{{ name.slice(0, 2).toUpperCase() }}</span>
    <div class="min-w-0">
      <h3 class="project-card-title text-truncate mb-1">{{ name }}</h3>
      <span class="badge bg-green-lt" *ngIf="item['active']">Active</span>
      <span class="badge bg-secondary-lt" *ngIf="!item['active']">Archived</span>
    </div>
  </div>
  <div class="project-card-stats">
    <span><strong>{{ branchCount }}</strong> branch{{ branchCount === 1 ? '' : 'es' }}</span>
    <span><strong>{{ memberCount }}</strong> member{{ memberCount === 1 ? '' : 's' }}</span>
  </div>
  <div>
    <div class="d-flex justify-content-between small mb-1"><span>Progress</span><strong>{{ progress | number:'1.0-0' }}%</strong></div>
    <div class="progress progress-sm"><div class="progress-bar bg-primary" [style.width.%]="progress"></div></div>
    <div class="small text-secondary mt-1">{{ item['completed_task_count'] || 0 }} / {{ item['task_count'] || 0 }} tasks complete</div>
  </div>
  <div class="d-flex gap-2 mt-auto">
    <span class="badge bg-blue-lt" *ngIf="item['billable']">Billable</span>
    <span class="badge bg-purple-lt" *ngIf="item['requires_timesheets']">Timesheets</span>
  </div>
</article>
